/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
//@ts-ignore
import { WebAppTemplate } from "../../components/templates/WebAppTemplate";
import styled from "styled-components";
import { ReferralStore } from "../../components/organisms/ReferralStore";
import { ReferralStatistics } from "../../components/molecules/ReferralStatistics";
import { ReferralForm } from "../../components/molecules/ReferralForm";
//@ts-ignore
import { ReferralStoreTitle } from "../../assets/icons/ReferralStoreTitle";
import { ReferralModal } from "../../components/molecules/ReferralModal";
import { InformationIcon } from "../../assets/icons/InformationIcon";
import { HowItWorks } from "./HowItWorks";
import { ReferralTimelineIcon } from "../../assets/icons/ReferralTimelineIcon";
import { Timeline } from "./Timeline";
import { toast } from "react-toastify";
import { GET_REFERRAL } from "./queries";
import { useMutation, useQuery } from "@apollo/client";
import { CLAIM_REWARD } from "./mutations";
//@ts-ignore
import { Spinner } from "../../assets/animations/spinner";
// @ts-ignore
import { BBLoadingGif } from "../../blackbook-components/quarks/blackbook-loading";
//@ts-ignore
import {useTrack} from "../../services/hooks/useTrack"
//@ts-ignore
import { useUser } from "../../context/useUser";
import { useHistory } from "react-router-dom";

type ModalState = {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
};

const Container = styled.main`
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  gap: 50px;
  height: calc(100vh - 86px);
  box-sizing: border-box;
  font-family: "Open Sans", sans-serif;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  border: 1px solid #6f6f6f;
  border-right: none;
  border-left: none;
  padding: 10px 5px;
`;

const Title = styled.h1`
  color: white;
  font-size: 30px;
`;

const InteractableSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
`;

const Text = styled.div`
  color: white;
  text-align: center;
  font-size: 18px;
  font-weight: 300;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px 0;
`;

const ButtonSection = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
`;

const Button = styled.button`
  background-color: #7515ed;
  border: none;
  color: white;
  border-radius: 20px;
  padding: 10px 20px;
  width: 40%;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
`;

const HorizontalContainer = styled.section`
  display: flex;
  justify-content: space-between;
  gap: 50px;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  padding: 0 10px 10px;
`;

const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  flex: 1;
`;

export const ReferralPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [trackingSent, setTrackingSent] = useState(false);
  const [showingHistory, setShowingHistory] = useState(false);
  const [loadingTransactions, setLoadingTransactions] = useState(false);
  const [currentModal, setCurrentModal] = useState<ModalState>({
    title: "",
    icon: <></>,
    children: <></>,
  });

  const { data, refetch } = useQuery(GET_REFERRAL);
  const [handleClaim] = useMutation(CLAIM_REWARD);
  const {trackEvent} = useTrack()
  const { activePlan } = useUser();
  const history = useHistory();
  const isUserB2BAssociated = activePlan?.origin
    .toLowerCase()
    .includes("b2b_crmdf");

  const claim = async (id: string) => {
    try {
      const { data } = await handleClaim({ variables: { productId: id } });
      return data;
    } catch (error) {
      console.error("Erro ao tentar resgatar recompensa:", error);
      toast.error("Erro ao tentar resgatar recompensa");
      return null;
    }
  };

  const openModal = (modal: ModalState) => {
    setCurrentModal(modal);
    setIsModalOpen(true);
  };

  const getHistoryModal = () => ({
    title: "Meu Histórico",
    icon: <ReferralTimelineIcon />,
    children:
      loadingTransactions ||
      !data?.rewardsUserTransactionsHistory?.transactions ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <Spinner />
        </div>
      ) : (
        <Timeline
          transactions={data.rewardsUserTransactionsHistory.transactions}
        />
      ),
  });

  useEffect(() => {
    if(isUserB2BAssociated) history.push("/app");
  }, [])

  useEffect(() => {
    if (data && trackingSent === false && data.showIndicationInfo) {
      setTrackingSent(true);
      trackEvent("Indique - Visualizou tela Indique e Ganhe", {
        "Convites aceitos":
          data?.showIndicationInfo?.invitationData.invitationsAccepted,
        "Amigos que concluíram assinatura":
          data?.showIndicationInfo?.invitationData.invitationsFinalized,
        "Saldo blackcoins": data?.rewardsUserBalance.totalBlackcoins,
      });
    }
  }, [data])

  useEffect(() => {
    if (isModalOpen && showingHistory) {
      openModal(getHistoryModal());
    }
  }, [data, isModalOpen, showingHistory, loadingTransactions]);

  const modalPicker = (modalType: string) => {
    if (modalType === "Como funciona?") {
      setShowingHistory(false);
      openModal({
        title: "Como funciona?",
        icon: <InformationIcon />,
        children: <HowItWorks />,
      });
    } else {
      setShowingHistory(true);
      openModal(getHistoryModal());
    }
  };

  return (
    <WebAppTemplate>
      {isModalOpen && (
        <ReferralModal
          indicationInfo={currentModal}
          isOpen={isModalOpen}
          setIsOpen={() => setIsModalOpen(false)}
        />
      )}
      {data ? (
        <Container>
          <TitleContainer>
            <ReferralStoreTitle />
            <Title>Indique e ganhe</Title>
          </TitleContainer>
          <HorizontalContainer>
            <LeftContainer>
              <InteractableSection>
                <Text>
                  Indique o Blackbook aos seus colegas, <br/> ganhe Blackcoins e
                  troque por prêmios no aplicativo.
                </Text>
                <ButtonSection>
                  <Button
                    onClick={() => {
                      trackEvent("Indique - Clicou em Como funciona", {
                        "Tipo da origem": "Indique e ganhe",
                      });
                      modalPicker("Como funciona?");
                    }}
                  >
                    Como funciona?
                  </Button>
                  <Button
                    onClick={() => {
                      trackEvent("Indique - Clicou em Meu Histórico");
                      modalPicker("Meu Histórico");
                    }}
                  >
                    Meu Histórico
                  </Button>
                </ButtonSection>
              </InteractableSection>
              <ReferralStatistics
                invitationData={{
                  invitationsAccepted:
                    data?.showIndicationInfo?.invitationData
                      .invitationsAccepted,
                  invitationsFinalized:
                    data?.showIndicationInfo?.invitationData
                      .invitationsFinalized,
                }}
              />
              <ReferralForm
                indicationInfo={{
                  url: `${process.env.REACT_APP_REFERRAL_URL}${data?.showIndicationInfo?.code}`,
                }}
              />
            </LeftContainer>
            <ReferralStore
              items={data?.rewardsProductsStore}
              balance={data?.rewardsUserBalance.totalBlackcoins}
              purchaseCompleted={async (
                id: string,
                data: {
                  Produto: string;
                  "Valor Giftcard": string;
                  "Preço em blackcoins": number | string;
                }
              ) => {
                setLoadingTransactions(true);
                modalPicker("Meu Histórico");
                const response = await claim(id);
                if (response) {
                  await refetch();
                  trackEvent("Indique - Comprou giftcard", data);
                  toast.success("Compra concluída com sucesso");
                }
                setLoadingTransactions(false);
              }}
            />
          </HorizontalContainer>
        </Container>
      ) : (
        <BBLoadingGif />
      )}
    </WebAppTemplate>
  );
};
